import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { LOGSEVERITY, LOGTYPE } from '@core/app.costants';
import { RolesHttpService } from '../roles-http.service';
import { WatchdogService } from '@services/watchdog.service';
import { RoleAddAction, RoleAddedAction, RoleAddPermissionAction, RoleDeleteAction, RoleDeletedAction, RoleErrorAddingAction, RoleErrorAddingPermissionAction, RoleErrorDeletingAction, RoleErrorLoadingAction, RoleErrorRemovingPermissionAction, RoleErrorUpdatingAction, RoleLoadAllAction, RoleLoadedAllAction, RolePermissionAddedAction, RolePermissionRemovedAction, RoleRemovePermissionAction, RoleUpdateAction, RoleUpdatedAction } from './role.actions';
import { IStoreState } from '@core/store/store.state';
import { NotificationService } from "@services/notification.service";

@Injectable()
export class RoleEffects {
  constructor(
    private actions$: Actions,
    private rolesHttpService: RolesHttpService,
    private router: Router,
    private watchdog: WatchdogService,
    private store: Store<IStoreState>,
    private notificationService: NotificationService
  ) { }

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleLoadAllAction),
      tap((action) =>
        this.rolesHttpService.findAllRoles().subscribe({
          next: situazioneRuoli => {
            this.store.dispatch(RoleLoadedAllAction({ situazioneRuoli: situazioneRuoli }));
          }, error: err => {
            this.store.dispatch(RoleErrorLoadingAction())
          }
        })
      )
    ), { dispatch: false }
  );

  deleteRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleDeleteAction),
      tap((action) =>
        this.rolesHttpService.deleteRole(action.id).subscribe({
          next: value => {
            this.notificationService.setNotification('Ruolo cancellato con successo.')
            this.store.dispatch(RoleDeletedAction({id: action.id}));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `L'utente ha eliminato il ruolo n.: ${action.id}`,
            });
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un errore nell'eliminazione del ruolo ${action.id}`,
            });
            this.store.dispatch(RoleErrorDeletingAction())
          }
        })
      )
    ),
    { dispatch: false }
  );

  addRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleAddAction),
      tap((action) =>
        this.rolesHttpService.addRole(action.role).subscribe({
          next: value => {
            this.store.dispatch(RoleAddedAction({ ruolo: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `L'utente ha aggiunto il ruolo ${value.ruolo}`,
            });

            this.router.navigate(['/private-area', 'roles', value.id_ruolo, 'edit']);

          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un errore durante l'eliminazione del ruolo ${action.role.id_ruolo}`,
            });
            this.store.dispatch(RoleErrorAddingAction());
          }
        })
      )
    ), { dispatch: false }
  );

  addPermissionToRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleAddPermissionAction),
      tap((action) =>
        this.rolesHttpService.addPermissionToRole(action.permissionToRole).subscribe({
          next: value => {
            this.store.dispatch(RolePermissionAddedAction({ permissionToRole: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `E' stato aggiunto il permesso ${action.permissionToRole.permessi[0]} al ruolo ${action.permissionToRole.id_ruolo} - ${action.permissionToRole.ruolo}`,
            });

          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un errore durante l'eliminazione del permesso ${action.permissionToRole} dal ruolo ${action.permissionToRole.id_ruolo}`,
            });
            this.store.dispatch(RoleErrorAddingPermissionAction());
          }
        })
      )
    ), { dispatch: false }
  );

  removePermissionFromRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleRemovePermissionAction),
      tap((action) =>
        this.rolesHttpService.removePermissionFromRole(action.permissionFromRole).subscribe({
          next: value => {
            this.store.dispatch(RolePermissionRemovedAction({ permissionFromRole: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `E' stato rimosso il permesso ${action.permissionFromRole} dal ruolo ${action.permissionFromRole}`,
            });
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.NONE,
              message: `Rimosso il permesso ${action.permissionFromRole} dal ruolo ${action.permissionFromRole}`,
            });
            this.store.dispatch(RoleErrorRemovingPermissionAction());
          }
        })
      )
    ), { dispatch: false }
  );

  updateRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleUpdateAction),
      tap((action) =>
        this.rolesHttpService.updateRole(action.role).subscribe({
          next: value => {
            this.store.dispatch(RoleUpdatedAction({ role: value }));

            this.watchdog.writeWatchdog({
              type: LOGTYPE.INFO,
              severity: LOGSEVERITY.NONE,
              message: `Il ruolo ${action.role.id_ruolo} è stato correttamente aggiornato`,
            });

            this.router.navigate(['/private-area', 'roles', 'list']);
          }, error: err => {
            this.watchdog.writeWatchdog({
              type: LOGTYPE.ERROR,
              severity: LOGSEVERITY.HIGHT,
              message: `Si è verificato un problema durante l'eliminazione del ruolo ${action.role.id_ruolo}`,
            });
            this.store.dispatch(RoleErrorUpdatingAction());
          }
        })
      )
    ), { dispatch: false }
  );
}
